import request from '@/utils/request'
import requestJxs from '@/utils/requestJxs'
import {getUserInfo} from '@/utils/common'
import {selectApi} from '@/config/config'
import requestOld from "@/utils/request";
import requestFxs from "@/utils/requestFxs";

// 登录
export const login = (data) => {
    return requestJxs('/jxs/user/login', {
        params: {
            type: 'account',
            ...data
        },
        ssgsbm: false,
        autojxs: false
    })
}

// 登录
export const loginSjh = (data) => {
    return requestFxs('/fxs/user/loginSjhWeb', {
        params: {
            type: 'account',
            ...data
        },
        ssgsbm: false,
        autojxs: false
    })
};

// 获取用户基本信息
export const getCurrentUser = () => {
    const userInfo = getUserInfo()
    if (userInfo) {
        return requestJxs('/jxs/user/currentUser', {
            params: {
                type: 'user/fetchCurrent',
                id: userInfo.sysid,
                lx: userInfo.lx,
                dlm: userInfo.dlm,
                mm: userInfo.mm,
            },
            autopass: true,
            autojxs: false
        })
    }
    return undefined
}

// 获取用户基本信息
export const getFxsCurrentUser = () => {
    const userInfo = getUserInfo()
    if (userInfo) {
        return requestFxs('/fxs/user/currentUser', {
            method: 'post',
            data: {
                type: 'user/fetchCurrent',
                id: userInfo.sysid,
                lx: userInfo.lx,
                dlm: userInfo.dlm,
                mm: userInfo.mm,
            }
        })
    }
    return undefined
}

// // 获取用户购物车数量
// export const getShopCarCount = () => {
//   const userInfo = getUserInfo()
//   return request('/frontend/shoppingcar/shoppingcarCount.do', {
//     params: {
//       dlid: userInfo.sysid
//     }
//   })
// }
// 获取用户购物车数量
export const getShopCarCount = (data) => {
    const userInfo = getUserInfo();
    return requestJxs('/jxs/Wdgwc/count', {
        method: 'post',
        data: {
            dlid: userInfo.sysid,
            ...data
        }
    })
}

// 清空购物车
export const clearShopCar = () => {
    const userInfo = getUserInfo()
    return request('/frontend/shoppingcar/clear.do', {
        params: {
            dlid: userInfo.sysid
        }
    })
}

// // 批量加入购物车
// export const addShopCars = (data) => {
//   const userInfo = getUserInfo()
//   return request('/frontend/shoppingcar/batchAdd.do', {
//     method: 'post',
//     data: {
//       dlid: userInfo.sysid,
//       data
//     }
//   })
// }

// 批量加入购物车
export const addShopCars = (data) => {


    const userInfo = getUserInfo()
    return requestJxs('/jxs/Wdgwc/batchAdd', {
        method: 'post',
        data: {
            dlid: userInfo.sysid,
            data
        }
    })
}

// 获取母公司信息
export const getPartner = (partner) => {
    return request(selectApi, {
        params: {
            sqlfilename: "new-sql-shll.xml",
            sqlkey: "get-jxs-parent",
            partner
        }
    })
}

// 获取母公司的母公司？
export const getGrandpartner = (jxsbm) => {
    return request(selectApi, {
        params: {
            sqlfilename: "new-sql-shll.xml",
            sqlkey: "jxs-parent-partner",
            jxsbm,
        }
    })
}

// 获取经销商详情
export const getJxsDetail = (id) => {
    return requestJxs('/jxs/QdUserDlmJxs/detail', {
        data: {
            id
        },
        method: 'post',
        autopass: true
    })
}

// 登录
export const selectValue = (data) => {
    return requestJxs('/jxs/mstSelectValue/selectByCode', {
        method: 'post',
        data: {
            ...data
        }
    })
}
// 短信验证
export const getDxyz = (data) => {
    return request('/backstage/sms/send.do', {
        params: {
            type: 'account',
            ...data
        },
    })
}

// 校验密码
export const checkPassord = (params) => {
    return request('/frontend/xtgl_jxsda_zh/checkPassword.do', {
        params,
        autopass: true
    })
}

// 设置密码
export const savePassword = (params) => {
    return request('/frontend/xtgl_jxsda_zh/setMm.do', {
        params
    })
}
